import React, { useState, useEffect } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import "./prize-item-content.scss"
import ContentHeader from "../../molecules/content-header/content-header"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import BackButton from "../../../shared/components/atoms/back-button/back-button"
import KeyEntry from "../../molecules/key-entry/key-entry"
import CrossMenu from "../../molecules/cross-menu/cross-menu"
import EnvironmentalCard from "../../atoms/environmental-card/environmental-card"
import ModalKeyEntry from '../../molecules/modal-key-entry/modal-key-entry';
import ShopCart from "../../molecules/shop-cart/shop-cart"
import ModalPrizeItem from "../../molecules/modal-prize-item/modal-prize-item"
import SpanBanner from "../../atoms/span-banner/span-banner"
import FormatNumber from "../../../shared/utils/formatNumber"
import MyPointsService from "../../../shared/services/my-points-service"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { withPrefix } from "gatsby-link"

const PrizeItemContent = props => {
  const { mobile, prize, setModalActive } = props

  const myKeysDefault = ""
  const [myKeys, setMyKeys] = useState(myKeysDefault)
  const [keyLoader, setkeyLoader] = useState(false)
  const [showModalKey, setShowModalKey] = useState(false);
  const [valueInput, setValueInput] = useState(null);

  const bntLogOut = [
    {
      title: "¿Qué son?",
      slug: "/que-son",
    },
    {
      title: "¿Qué puedo ganar?",
      slug: "/que-puedo-ganar",
    },
    {
      title: "Ingreso de claves",
      slug: "/ingreso-de-claves",
    },
  ]

  const bntLogIn = [
    {
      title: "Mis movimientos",
      slug: "/mis-movimientos",
    },
    {
      title: "¿Qué son?",
      slug: "/que-son",
    },
    {
      title: "¿Qué puedo ganar?",
      slug: "/que-puedo-ganar",
    },
  ]

  const [isLogIn, setIsLogIn] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [prizeSoldOut, setprizeSoldOut] = useState(0)
  const [prizeSize, setprizeSize] = useState([])
  const myPointsLink = siteUrl + "/mis-puntos/que-puedo-ganar"

  const handleModalActive = () => {
    setModalActive(
      <ModalPrizeItem
        setModalClose={() => {
          var body = document.getElementsByTagName("body")[0]
          var html = document.getElementsByTagName("html")[0]
          body.classList.remove("overflow-body-hidden")
          html.classList.remove("overflow-body-hidden")
          setModalActive(null)
        }}
        prize={prize}
        prizeSize={prizeSize}
      />
    )
  }

  const addPrize = () => {
    var prizes = localStorage.getItem("USER_PRIZES")
      ? JSON.parse(localStorage.getItem("USER_PRIZES"))
      : []
    var existPrize = false

    if (prizes.length > 0)
      existPrize = setQuantityPrize(prizes, prize.codigoDePremio)

    if (!existPrize) {
      prizes.push({
        codigoDePremio: prize.codigoDePremio,
        numeroDePuntos: prize.numeroDePuntos,
        nombreDelBono: prize.nombreDelBono,
        imgUrl: prize.imagenDelPremioCompleta.file.url,
        prize: prizeSize,
        size: prizeSize[0].size,
        cantidad: 1,
      })
    }

    localStorage.setItem("USER_PRIZES", JSON.stringify(prizes))
  }

  const handleClick = () => {
    if (!localStorage.getItem("TOKEN_INFO")) {
      sessionStorage.setItem("NEXT_PAGE", window.location.pathname)
      window.location.replace(siteUrl + "/login")
    } else {
      addPrize()
      handleModalActive()
    }
  }

  const setQuantityPrize = (array, valueFilter) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].codigoDePremio === valueFilter) {
        array[i].cantidad++
        return true
      }
    }

    return false
  }

  const [keySubmit, setKeySubmit] = useState([])

  useEffect(() => {
    setPageLoad(true)
    if (localStorage.getItem("USER_INFO"))
      setIsLogIn(localStorage.getItem("TOKEN_INFO"))

    getPrize()
  }, [])

  const getPrize = () => {
    MyPointsService.getQuantitiyPrice(prize.codigoDePremio)
      .then(res => {
        if (res.status === 400 || res.status === 404) {
        } else if (res.status === 200) {
          setprizeSize(res.data)
          setprizeSoldOut(parseInt(res.data[0].quantity))
        }
      })
      .catch(err => console.log(err))
  }

  const loginRedirect = () => {
    window.location.href = siteUrl + "/login"
  }

  const getInfoProduct = (keyProduct) => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {

      setkeyLoader(true)
      let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId
        },
      }

      let key = keyProduct.toUpperCase()

      const GenericIntimaWear = [
        "2T", "2S", "S2"
      ]

      const GenericBuenasNoches = [
        "LZ", "MC", "ZL", "H1", "NS"
      ]

      MyPointsService.getKeyProduct(key, config).then(res => {
        if (res.status === 400 || res.status === 404) {
          setKeySubmit(res)
          setkeyLoader(false)
        } else if (res.status === 200 && GenericIntimaWear.includes(res.data.generico) || GenericBuenasNoches.includes(res.data.generico)) {
          setShowModalKey(true);
          setkeyLoader(false);

        } else if (res.status === 200 && !GenericIntimaWear.includes(res.data.generico) || !GenericBuenasNoches.includes(res.data.generico)) {
          addKeys(keyProduct, '')
        }
      }).catch(err => console.log('Error:', err))

    }
  }

  const addKeys = (keyValue, codeValue) => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      // setkeyLoader(true)
      let userInfo = JSON.parse(localStorage.getItem("USER_INFO"))
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      let payload = {
        activity: "",
        // productGeneric: codeValue,
        key: {
          code: keyValue.toUpperCase(),
        },
      }

      MyPointsService.postMyKeys(payload, codeValue, config)
        .then(res => {
          if (res.status === 400 || res.status === 404) {
            setKeySubmit(res)
            setkeyLoader(false)
          } else if (res.status === 200) {
            // DataLayer
            try {
              window.dataLayer.push({
                event: "salesForcePush",
                convid: "null",
                displayorder: "null",
                linkalias: "Acumula Puntos",
                amt: res.data.points,
                unit: res.data.points,
              })
            } catch (e) {
              console.log("Error", e)
            }
            setKeySubmit(res)
            userInfo.userPoints.pointsAccumulation += res.data.points
            localStorage.setItem("USER_INFO", JSON.stringify(userInfo))
            if (!mobile) {
              document.getElementById("points-user").innerHTML =
                FormatNumber(
                  userInfo.userPoints.pointsAccumulation +
                  userInfo.userPoints.pointsPresent
                ) + " PUNTOS"
            }
            setMyKeys(myKeysDefault)
            setkeyLoader(false)
            setShowModalKey(false)
            setValueInput(null)
          }
        })
        .catch(err => console.log(err))
    } else {
      sessionStorage.setItem("NEXT_PAGE", window.location.pathname)
      loginRedirect()
    }
  }

  return (
    <div className="f-prize-item">
      <ContentHeader mobile={mobile} />

      {isLogIn && <SpanBanner mobile={mobile} />}

      <div className="f-breadcrum-position">
        <Breadcrumb mobile={mobile} />
      </div>

      {pageLoad && !mobile && <EnvironmentalCard />}

      <CrossMenu
        mobile={mobile}
        btnOptions={isLogIn ? bntLogIn : bntLogOut}
        btnActiveDefault={isLogIn ? 2 : 1}
        isLogIn={isLogIn}
      />
      {process.env.LOCALE === "es-UY" ? null : (
        <ShopCart mobile={mobile} isLogIn={isLogIn} />
      )}
      <KeyEntry
        mobile={mobile}
        // addKeys={addKeys}
        getInfoProduct={getInfoProduct}
        setKeySubmit={setKeySubmit}
        keySubmit={keySubmit}
        myKeys={myKeys}
        setMyKeys={setMyKeys}
        isLogIn={isLogIn}
        keyLoader={keyLoader}
      />

      {pageLoad && <ModalKeyEntry
        showModalKey={showModalKey}
        setShowModalKey={setShowModalKey}
        valueInput={valueInput}
        setValueInput={setValueInput}
        addKeys={addKeys}
        myKeys={myKeys}
        keySubmit={keySubmit}
      />}

      <div className="f-prize-item-content">
        <div className="f-prize-item-content-wrap">
          <BackButton
            title="VOLVER"
            onClick={e => {
              e.preventDefault()
              window.location = myPointsLink
            }}
          />

          <div className="f-prize-item-content-wrap-img">
            <img
              src={
                pageLoad
                  ? prize.imagenDelPremioCompleta.file.url
                  : prize.imagenDelPremioCompleta.fluid.base64
              }
              alt={prize.imagenDelPremioCompleta.description}
            />
          </div>

          <div className="f-prize-item-content-wrap-info">
            <h1> {prize.nombreDelBono} </h1>
            <h2> {FormatNumber(prize.numeroDePuntos)} puntos</h2>
            {documentToReactComponents(prize.descripcionDelBono.json)}
            {prizeSoldOut === 0 && (
              <label className="f-soldout">
                El premio se encuentra agotado.
              </label>
            )}
            {prizeSoldOut > 0 && (
              <button
                className={
                  "primary-pink" + (prizeSoldOut > 0 ? " f-spacin-btn" : "")
                }
                disabled={prizeSoldOut > 0 ? false : true}
                onClick={e => {
                  e.preventDefault()
                  handleClick()
                }}
              >
                Agregar al carrito
              </button>
            )}
            {/* <Button
              className="primary-pink"
              title="Agregar al carrito"
              onClick={(e) => { e.preventDefault(); handleClick() }}
            /> */}
          </div>

          <div className="f-prize-item-content-wrap-list">
            {documentToReactComponents(prize.condicionesDeRedencion.json)}
            {prize.type === "virtual" && (
              <ul>
                <li>
                  <p>
                    Ver mas condiciones{" "}
                    <a
                      download="condiciones.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        prize.codigoDePremio === "NOL_PREMIO_044" // Bono de Tennis por $30.000
                          ? withPrefix(`/Bono-Tennis-TyC.pdf`)
                          : prize.codigoDePremio === "NOL_PREMIO_045" // Bono Librería Nacional
                          ? withPrefix(`/Bono-Libreria-Nacional-TyC.pdf`)
                          : withPrefix(`/condiciones-premios.pdf`)
                      }
                    >
                      aquí
                    </a>
                  </p>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      <div className="f-space"></div>
    </div>
  )
}

export default PrizeItemContent
